import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RegisterOptions, useFormContext } from "react-hook-form";

export interface IFormInputProps
    extends React.DetailedHTMLProps<
        React.InputHTMLAttributes<HTMLInputElement>,
        HTMLInputElement
    > {
    // propriedade herdadas obrigatórias
    name: string;
    ref?: undefined;
    // outras propriedades
    wrapperClassName?: string;
    labelClassName?: string;
    registerOptions?: RegisterOptions;
    label?: string;
    isIcon?: boolean;
    icon?: IconProp;
    iconText?: string;
    // Correct the type of the onClick event handler
    onClick: () => void;
}

export default function FormInput(props: IFormInputProps) {
    const { register, formState } = useFormContext();

    const {
        wrapperClassName,
        registerOptions,
        label,
        labelClassName,
        isIcon = true,
        iconText,
        onClick,
        icon,
        ...inputProps
    } = props;

    /**@todo mudar isso para uma função no tools e chamar em todos os componentes do Unform */
    function getErrorObject(name: string) {
        const namesArray = name.split(".");

        const finalObj = namesArray.reduce(
            (finalObj, namePart) => finalObj?.[namePart],
            formState.errors
        );

        return finalObj;
    }

    const error = getErrorObject(props.name);

    return (
        <span className={wrapperClassName}>
            {label && <label className={labelClassName}>{label}</label>}
            <div className="d-flex flex-row">
                <input
                    {...inputProps}
                    className={`form-control placeholder-dark-75 ${
                        inputProps.className
                    } ${error && "is-invalid"}`}
                    ref={register(registerOptions)}
                />
                <button className="btn btn-primary" onClick={onClick}>
                    {isIcon && icon ? (
                        <FontAwesomeIcon icon={icon} />
                    ) : (
                        iconText
                    )}
                </button>
            </div>
            <div className="invalid-feedback">{error?.message}</div>
        </span>
    );
}
